import { render, staticRenderFns } from "./PaymentFailPrepare.vue?vue&type=template&id=6455634a&"
import script from "./PaymentFailPrepare.vue?vue&type=script&lang=js&"
export * from "./PaymentFailPrepare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports